import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { jitteredPollMs } from '~/utils/jitter';

import { refetchOnShow, runPollBaseMs } from '../constants/polling';
import { getRunProgress } from '../services/run.service';

/**
 * A run's live progress. Polls ~4 s (±15%) while the run moves on its own, ~30 s while an open
 * gate waits on a person, and stops once terminal (constants/polling.ts). Never polls a hidden
 * tab; a poll missed while hidden runs once on show. Every run tab reads this one cache
 * entry, so the rail, gate and recovery views never disagree.
 */
export function useRunProgress(runRef: string) {
  return useQuery({
    queryKey: queryKeys.catalogService.runProgress(runRef),
    queryFn: () => getRunProgress(runRef),
    enabled: !!runRef,
    // ±15% per query instance, so many open run tabs do not poll in step.
    refetchInterval: (query) => {
      const base = runPollBaseMs(query.state.data?.runStatus);
      return base === false ? false : jitteredPollMs(query, base);
    },
    refetchIntervalInBackground: false,
    // A poll that fell due while the tab was hidden runs once when it is shown again.
    refetchOnWindowFocus: (query) =>
      refetchOnShow(query.state.dataUpdatedAt, runPollBaseMs(query.state.data?.runStatus)),
  });
}
